import React, { useEffect, useMemo, useState } from "react";
import {  Box, Button, Grid, TextField, Typography } from "@mui/material";
import {  useCourseMappingNoteList, useCourseScoreCardLoading } from "hooks/CourseMapDetails";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Delete_coursemap_scorecard_image, course_mapping_note_create, course_mapping_note_list, course_scorecard_details, course_sync_output_create, course_teecolor_list, course_teetype_create, course_teetype_list, update_coursemap_scorecard, upload_coursemap_scorecard_image } from "redux/CourseMapSlice";
import {
  calculateSumforIndex,
  calculatedSum,
  dateTimeFormat,
  decryptSecretKey,
  normalizeUrl,
} from "services/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import DragDropFileInput from "components/DragDropFile/DragDropFile";
import DraggableList from "components/DraggableList/DraggableList";
import useNotiStack from "hooks/useNotistack";
import asset from "json/assets";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import Wrapper from "layout/Wrapper/Wrapper";
import BackdropLoader from "ui/BackdropLoader/BackdropLoader";
import CustomButton from "ui/CustomButton/CustomButton";
import CustomInputNoLabel from "ui/CustomInputNoLabel/CustomInputNoLabel";
import CustomInput from "ui/CustomInput/CustomInput";
import * as yup from "yup";
import moment from "moment";
import SideBarActions from "layout/SideBarActions/SideBarActions";

import wrapperStyles from "styles/pages/Map1.module.scss";
import styles from "styles/pages/ScoreDetails.module.scss";
import stylesModal from "styles/pages/modal.module.scss";
import _style from "styles/component/CourseMappingNotePopOver.module.scss";

const sortTeeTypes = (list) =>
  [...list].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

// notesSchema
const notesSchema =  yup.object().shape(
  {
    notes: yup
        .string()
        .trim()
        .required("This field is required"),
  }
)

export default function CourseMappingScorecardDetails() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useNotiStack();
  const loadingState =useCourseScoreCardLoading();
  const [searchParams] = useSearchParams();
  const secret_Key = decryptSecretKey();
  const courseIdFromQuery = searchParams.get("courseId");
  const profileDetails = JSON.parse(localStorage.getItem("profile_data"));
  const mappingNoteList = useCourseMappingNoteList()?.noteList;

  const [courseScoreCardDetails, setCourseScoreCardDetails] = useState();
  const [teeColorList, setTeeColorList] = useState()
  const [teeTypeList, setTeeTypeList] = useState([])
  const [courseTeeList, setCourseTeeList] = useState([]);
  const [teeListArray, setTeeListArray] = useState([]);
  const [hole, setHole] = useState([]);
  const [parForMnH9, setParForMnH9] = useState([]);
  const [parForMnH18, setParForMnH18] = useState([]);
  const [parForWmnH9, setParForWmnH9] = useState([]);
  const [parForWmnH18, setParForWmnH18] = useState([]);
  const [HCPForMnH9, setHCPForMnH9] = useState([]);
  const [HCPForMnH18, setHCPForMnH18] = useState([]);

  const [HCPForWmnH9, setHCPForWmnH9] = useState([]);
  const [HCPForWmnH18, setHCPForWmnH18] = useState([]);
  const [scorecardTeeList, setscorecardTeeList] = useState()
  const [openNotesModal, setOpenNotesModal] = useState(false);
  const emptyYdsHoleArray =  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
  const emptyScoreValue =  [0,0,0,0,0,0,0,0,0];
  const [sideBarExpanded, setSideBarExpanded] = useState();
  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors, isDirty },
  } = useForm({});

  const {
    handleSubmit: handleSubmitNotes,
    control : controlNotes,
    // watch,
    reset : resetNotes,
    formState: { errors: errorsForNotes },
  } = useForm({
    resolver: yupResolver(notesSchema),
  });

  useEffect(() => {
    reset({
      courseWebsiteURL: courseScoreCardDetails?.courseURL,
      scoreCardUrl: courseScoreCardDetails?.url,
    });
  }, [courseScoreCardDetails]);

  useEffect(() => {
    dispatch(
      course_scorecard_details({
        body: {
          id_course: Number(courseIdFromQuery),
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    ).then((res) => {
      if (res.payload.data.Status === 1) {
        setCourseScoreCardDetails(res.payload.data);
      }
    });

    dispatch(course_teecolor_list({
      body:{
        active: 1
      },
      user: {
        secretKey: secret_Key,
        userName: profileDetails?.username,
      },
    })).then((res)=>{
    
      if(res?.payload?.data?.Status === 1){
        setTeeColorList(res?.payload?.data)

      }
    })

    dispatch(course_teetype_list(
      {
        body:{
          active: 1
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      }
    )).then((res)=> {
      if(res?.payload?.data.Status === 1){
        setTeeTypeList(sortTeeTypes(res?.payload?.data?.courseTeeTypeList ?? []))
      }
    })

    course_map_noteList()
   

  }, []);

  const course_map_noteList = ()=> {
    dispatch(course_mapping_note_list({
      body: {
        id_course: Number(courseIdFromQuery),
      },
      user: {
       secretKey: secret_Key,
       userName: profileDetails?.username,
      },
    })).then((res)=> {
    })
  }



  useEffect(() => {
    if (courseScoreCardDetails && courseScoreCardDetails?.menScorecardList?.length) {
      setHCPForMnH9(
        courseScoreCardDetails?.menScorecardList[0]?.hcpHole?.slice(0, 9)
      );
      setHCPForMnH18(
        courseScoreCardDetails?.menScorecardList[0]?.hcpHole?.slice(9, 18)
      );
      setHCPForWmnH9(
        courseScoreCardDetails?.wmnScorecardList[0]?.hcpHole?.slice(0, 9)
      );
      setHCPForWmnH18(
        courseScoreCardDetails?.wmnScorecardList[0]?.hcpHole?.slice(9, 18)
      );
      setParForMnH9(
        courseScoreCardDetails?.menScorecardList[0]?.parHole?.slice(0, 9)
      );
      setParForMnH18(
        courseScoreCardDetails?.menScorecardList[0]?.parHole?.slice(9, 18)
      );
      setParForWmnH9(
        courseScoreCardDetails?.wmnScorecardList[0]?.parHole?.slice(0, 9)
      );
      setParForWmnH18(
        courseScoreCardDetails?.wmnScorecardList[0]?.parHole?.slice(9, 18)
      );
    }
  }, [courseScoreCardDetails]);
  const noTeeScoreCardDetails  = useMemo(()=> {
    if(scorecardTeeList?.length === 0 && courseScoreCardDetails?.menScorecardList?.length === 0){
      setHCPForMnH9(emptyScoreValue);
      setHCPForMnH18(emptyScoreValue);
      setParForMnH9(emptyScoreValue);
      setParForMnH18(emptyScoreValue);
    }
    if(scorecardTeeList?.length === 0 && courseScoreCardDetails?.wmnScorecardList?.length === 0){
      setHCPForWmnH9(emptyScoreValue);
      setHCPForWmnH18(emptyScoreValue);
      setParForWmnH9(emptyScoreValue);
      setParForWmnH18(emptyScoreValue);
    }
   
  },[scorecardTeeList?.length, courseScoreCardDetails?.menScorecardList?.length, courseScoreCardDetails?.wmnScorecardList?.length])


  useEffect(() => {
    if (courseScoreCardDetails?.teesList) {
      // const newHolesArray = courseScoreCardDetails.teesList.map((e) => {
      const newHolesArray = teeListArray?.map((e) => {
        const newArray = [...e.ydsHole];
        newArray.splice(0, 0, e.teeColorValue);
        return newArray;
      });
      setHole(newHolesArray);
    }
  }, [teeListArray]);
  useEffect(() => {
   if(hole){
    const newHolesArray = hole?.map((e) => {
      const newArray = [...e];
      // newArray?.slice(0)
      newArray.splice(10, 0, calculateSumforIndex(e,1,10));
      newArray.splice(20, 0, calculateSumforIndex(e,10,19));
      return newArray;
    });
    const modifiedArray = [...newHolesArray]
    setscorecardTeeList(modifiedArray)
   }
  }, [hole])

  const calculateScorecard = (hcpHole, parHole) => ({
    hcpHole,
    parHole,
    parIn: calculatedSum(parHole?.slice(0, 9) || []),
    parOut: calculatedSum(parHole?.slice(9, 18) || []),
    parTotal: calculatedSum(parHole || []),
  });
  
  const menScorecardList = [calculateScorecard([...HCPForMnH9, ...HCPForMnH18], [...parForMnH9, ...parForMnH18])];
  const wmnScorecardList = [calculateScorecard([...HCPForWmnH9, ...HCPForWmnH18], [...parForWmnH9, ...parForWmnH18])];

  // mmmmm
  // const parValueForMn = [...parForMnH9,...parForMnH18];
  // const menScorecardList = [{
  //   hcpHole: [...HCPForMnH9,...HCPForMnH18],
  //   parHole: parValueForMn,
  //   parIn: calculatedSum(parForMnH9),
  //   parOut: calculatedSum(parForMnH18),
  //   parTotal: calculatedSum(parValueForMn)
  // }];
  
 
  // const parValueForWmn = [...parForWmnH9,...parForWmnH18];
  // const wmnScorecardList = [{
  //   hcpHole: [...HCPForWmnH9,...HCPForWmnH18],
  //   parHole: parValueForWmn,
  //   parIn: calculatedSum(parForWmnH9),
  //   parOut: calculatedSum(parForWmnH18),
  //   parTotal: calculatedSum(parValueForWmn)
  // }];
  // mmmm

  const handleChange = (index, newValue, setArr) => {
    setArr((prevState) => {
      const newArr = [...prevState];
      newArr[index] = newValue === "" ? 0 : parseInt(newValue);
      return newArr;
    });
  };
  const handleChangeTee = (rowIndex, columnIndex, value) => {

    const updatedHole = [...hole];
if(columnIndex >=10 ){
  updatedHole[rowIndex][columnIndex ] = Number(value);
}else{
  updatedHole[rowIndex][columnIndex + 1] = Number(value);
}

    setHole(updatedHole);


  const modifiedYdsValue = hole?.map((e)=> e?.slice(1))

  teeListArray?.forEach((teeObject, index) => {

    teeObject.ydsHole = modifiedYdsValue[index];
  });
  // .... // for scorecard tee add 

  };

  const onSubmit = (data) => {

  const prepareUpload = () => {
    if (!data?.scoreCardImage?.length) return Promise.resolve();
    
    const validImage = data.scoreCardImage.find(item => item.path);
    if (!validImage) return Promise.reject("No valid image");

    const dto = {
      id_course: Number(courseIdFromQuery),
      filename: validImage.name,
      file: validImage
    };

    const formData = new FormData();

    formData.append(
      "request",
      new Blob([JSON.stringify(dto)], { type: "application/json" })
    );

    formData.append("file", validImage, validImage.name);
    
      return Promise.resolve(formData);
    };
    
    dispatch(update_coursemap_scorecard({
      body:{
        courseName: courseScoreCardDetails?.courseName,
        city: courseScoreCardDetails?.city,
        stateShort: courseScoreCardDetails?.stateShort,
        zipCode: courseScoreCardDetails?.zipCode,
        id_country: courseScoreCardDetails?.id_country,
        countryFull: courseScoreCardDetails?.countryFull,
        countryShort: courseScoreCardDetails?.countryShort,
        layoutHoles: courseScoreCardDetails?.layoutHoles,
        phone: courseScoreCardDetails?.phone,
        // scorecardModified: courseScoreCardDetails?.scorecardModified,
        id_course: Number(courseIdFromQuery),
        // imageArray:[],
        courseURL: normalizeUrl(data?.courseWebsiteURL),
        address1: courseScoreCardDetails?.address1,
        url: normalizeUrl(data?.scoreCardUrl),
        teesList: teeListArray,
        // menScorecardList:[],
        // wmnScorecardList: [],
        menScorecardList: scorecardTeeList?.length > 0 ? menScorecardList[0]?.hcpHole?.length && menScorecardList[0]?.parHole?.length ?  menScorecardList : [] : [],
        wmnScorecardList: scorecardTeeList?.length > 0 ? wmnScorecardList[0]?.hcpHole?.length &&  wmnScorecardList[0]?.parHole?.length ? wmnScorecardList : [] : []
      },
      user: {
        secretKey: secret_Key,
        userName: profileDetails?.username,
      },
    })).then((res)=> {
      if(res.payload.data.Status === 1){
        toastSuccess("Coursemap scorecard Data updated successfully")
        if(watch("scoreCardImage") !== undefined && watch("scoreCardImage")?.length !== 0){
          prepareUpload().then(formData => {
            
            dispatch(upload_coursemap_scorecard_image(
              {
              body: formData,
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },image: true
            }
            )).then((res)=> {
              if(res?.payload?.data?.Status === 1){
                // toastSuccess("Uploaded successfully.")
                // navigate("/coursemap")
              } else if(res?.payload?.data?.Status === 1001){
                toastError(`File could not be uploaded. ${res?.payload?.data?.ErrorMessage}`)
              }
              })
          })
        }
        dispatch(
          course_sync_output_create({
            body: {
              id_course: Number(courseIdFromQuery),
            },
            user: {
              secretKey: secret_Key,
              userName: profileDetails?.username,
            }
          })
        ).then((res)=>{
          if(res?.payload?.data?.Status === 1){
            // toastSuccess("Coursemap scorecard Data updated successfully")
            navigate("/coursemap")
          
          }else if(res?.payload?.data?.Status === 501){
            toastError(`${res?.payload?.data?.ErrorDetails?.name} ${res?.payload?.data?.ErrorMessage}`)
          }else if(res?.payload?.data?.Status === 503){
            // toastError("Incomplete data submitted, could not be processed")
            navigate("/coursemap")
          }
        })
      }else{
        toastError("Something went wrong")
      }
    })
  };

  const handleCreateTeeType = async (name) => {
    const res = await dispatch(course_teetype_create({
      body: { name },
      user: {
        secretKey: secret_Key,
        userName: profileDetails?.username,
      },
    }));
    const data = res?.payload?.data;
    if (Number(data?.Status) !== 1) {
      toastError(data?.ErrorMessage || "Failed to create tee type");
      return null;
    }
    const created = { id_courseTeeType: Number(data.id_courseTeeType), name };
    setTeeTypeList((prev) => sortTeeTypes([...prev, created]));
    toastSuccess(`Tee type "${name}" created`);
    return created;
  };

 const handleNewTeeBoxArray = (TeeData)=>{
  const modifiedTeeListArray = TeeData?.map(item => ({
    ...item,
    displayOrder: Number(item?.displayOrder)
  }));
  setTeeListArray(modifiedTeeListArray)
  }
  
  const handleAddDraggableRow = ()=>{
    const defaultTeeType = teeTypeList[0];
    const newRow = {
      displayOrder: teeListArray?.length.toString(),
      ratingMen: 0.0,
      ratingWomen: 0.0,
      slopeMen: 0,
      slopeWomen: 0,
      gender: "men",
      teeName: defaultTeeType?.name ?? "",
      teeColorName: "white",
      teeColorValue: "#000000",
      id_courseTeeColor: 2,
      id_courseTeeType: defaultTeeType?.id_courseTeeType ?? 1,
      yds1to9: calculateSumforIndex(emptyYdsHoleArray,0,9),
      yds1to18: calculatedSum(emptyYdsHoleArray),
      yds10to18: calculateSumforIndex(emptyYdsHoleArray,9,18),
      ydsHole: emptyYdsHoleArray,
      ydsTotal: calculatedSum(emptyYdsHoleArray)
    };

    setCourseTeeList([...teeListArray, newRow]);


      // Update the scorecardTeeList with the new tee box
      const addedYdsHole = [...newRow.ydsHole]
      addedYdsHole.splice(0, 0,"00000");
   
  const newScorecardTeeList = [...hole, addedYdsHole];
  const modifiedArray = newScorecardTeeList.map((e) => {
    const newArray = [...e];

    return newArray;
  });

  setHole(modifiedArray);

// // add par & hcp
//   if(courseScoreCardDetails?.menScorecardList[0]?.parHole === undefined){
//     setParForMnH9(emptyScoreValue);
//     setParForMnH18(emptyScoreValue);
//   }
//   if(courseScoreCardDetails?.menScorecardList[0]?.hcpHole === undefined){
//     setHCPForMnH9(emptyScoreValue);
//     setHCPForMnH18(emptyScoreValue);
//   }
//   if(courseScoreCardDetails?.wmnScorecardList[0]?.parHole === undefined){
//     setParForWmnH9(emptyScoreValue);
//     setParForWmnH18(emptyScoreValue);
//   }
//   if(courseScoreCardDetails?.wmnScorecardList[0]?.hcpHole === undefined){
//     setHCPForWmnH9(emptyScoreValue);
//     setHCPForWmnH18(emptyScoreValue);
//   }

  }
  const onSubmitNotes = (data)=>{

     dispatch(course_mapping_note_create({
      body: {
        note: data?.notes,
        id_course: Number(courseIdFromQuery),
      },
      user: {
        secretKey: secret_Key,
        userName: profileDetails?.username,
      },
    })).then((res)=> {

      if(res.payload.data.Status === 1){
        course_map_noteList()
        resetNotes({
          notes: ""
        })
      }
    })
  }

const handleDeleteScorecardImage = (selectImgFile)=>{
    if(selectImgFile?.id_image){
      dispatch(Delete_coursemap_scorecard_image({
        body: {
           id_course: Number(courseIdFromQuery),
           removeImageArray: selectImgFile?.id_image
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        } 
    })).then((res)=> {
    if(res.payload.data.Status === 1){
     
      toastSuccess("Scorecard image deleted successfully ")
     
    }else{
  
    
    }
    })
    }

}

  return (
    <div className="main_wraper">
      <Wrapper isHeader={true} headerTitle={"COURSE MAP"}>
        {loadingState === "loading" &&  <BackdropLoader open={true} />}
          <div
            className={
              sideBarExpanded
                ? `${wrapperStyles.main_wrapper_flex}`
                : `${wrapperStyles.main_wrapper_flex} ${wrapperStyles.main_wrapper_flex_open}`
            }
          >
            <div className={wrapperStyles.main_left}>
              <div className={styles.sideBar}>
                <SideBarActions 
                  form='scoreCard'
                  onCancelClick={() => navigate("/coursemap")}
                  toggleSideBar={() => setSideBarExpanded(prev => !prev)} />
              </div>
            </div>
            <div className={wrapperStyles.main_rgt}>
              <div className={styles.score_sec}>
                <form id='scoreCard' onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={0}>
                    <Grid item md={6} xs={12}>
                      <div className={`${styles.score_sec_box} ${styles.score_sec3}`}>
                        <div className={styles.score_head}>
                          {/* <p>#4274 - Riverwalk Golf Course</p> */}
                          <p>{` #${courseIdFromQuery} - ${
                            courseScoreCardDetails?.courseName || "--"
                          }`}</p>
                          <button type="button" onClick={() => setOpenNotesModal(true)}>
                          <img src={asset.noteIcon} alt="img" />
                          </button>
                        </div>
                        <div className={styles.formSec}>
                          <div className={styles.addressSec}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <div className={styles.addressSec_inr}>
                                  <p>ADDRESS:</p>
                                  <p> {courseScoreCardDetails?.address1 || "-"}</p>
                                  <p>{`${courseScoreCardDetails?.city || "-"},${courseScoreCardDetails?.stateShort || "-"} ${courseScoreCardDetails?.zipCode || "-"}`}</p>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <div className={styles.addressSec_inr}>
                                  <p>
                                    {" "}
                                    NUMBER OF HOLES:{" "}
                                    {`${courseScoreCardDetails?.layoutHoles || "-"}`}
                                  </p>
                                  <p> PHONE: {`${courseScoreCardDetails?.phone || "-"}`}</p>
                                  <p>
                                    {" "}
                                    SCORECARD MODIFIED:{" "}
                                    {`${dateTimeFormat(
                                      courseScoreCardDetails?.scorecardModified
                                    )}`  || "-"}
                                  </p>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
    
                          <Grid container spacing={0}>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <label>
                                      COURSE WEBSITE: <a href={normalizeUrl(watch('courseWebsiteURL'))} target="_blank" rel="noreferrer"><u>OPEN</u></a>{" "}
                                    </label>
                                  </Grid>
                                  {/* <Grid item xs={7} md={7}>
                                    {errors?.rangeName?.message && (
                                      <p className={styles.requiredContent}>
                                        {errors.rangeName.message}
                                      </p>
                                    )}
                                  </Grid> */}
                                </Grid>
                                <Controller
                                  control={control}
                                  name="courseWebsiteURL"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="text"
                                      value={value}
                                      onChange={onChange}
                                      // label="Range Name *"
                                      // error={Boolean(errors?.rangeName)}
                                      // helperText={errors?.rangeName?.message}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <label>
                                      SCORECARD SOURCE URL: <a href={normalizeUrl(watch('scoreCardUrl'))} target="_blank" rel="noreferrer"><u>OPEN</u></a>{" "}
                                    </label>
                                  </Grid>
                                  {/* <Grid item xs={7} md={7}>
                                    {errors?.rangeName?.message && (
                                      <p className={styles.requiredContent}>
                                        {errors.rangeName.message}
                                      </p>
                                    )}
                                  </Grid> */}
                                </Grid>
                                <Controller
                                  control={control}
                                  name="scoreCardUrl"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="text"
                                      value={value}
                                      onChange={onChange}
                                      // error={Boolean(errors?.rangeName)}
                                      // helperText={errors?.rangeName?.message}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <label>SCORECARD IMAGES - UP TO FOUR:</label>
                                  </Grid>
                                  {/* <Grid item xs={7} md={7}>
                                    {errors?.rangeName?.message && (
                                      <p className={styles.requiredContent}>
                                        {errors.rangeName.message}
                                      </p>
                                    )}
                                  </Grid> */}
                                </Grid>
                                <div className={styles.drag_img}>
                                  {/* {courseScoreCardDetails?.imageArray?.length ? 
                                  <>
                                  <figure>
                                  <img src={asset.mapImg} alt="" />
                                </figure>
                                <button className={styles.close_icon}>
                                <img src={asset.close} alt="" />
                              </button> 
                                  </>
                                  : null
                                  } */}
                                    <Controller
                                        control={control}
                                        name="scoreCardImage"
                                        render={({  field: { value, onChange, ...field } }) => (
                                            <DragDropFileInput accept="image/png, image/jpg, image/jpeg" 
                                              multiple
                                              name="scoreCardImage"
                                              mode="append"
                                              onChange={onChange}
                                              coursescoreCardImg={courseScoreCardDetails?.imageArray}
                                              removeImgFile={handleDeleteScorecardImage} />
                                    )} />
                                
                                  {/* <p> {courseScoreCardDetails?.imageArray?.length  ? 
                                  "CLICK OR DRAG SCORECARD IMAGES TO UPLOAD TO DATABASE"
                                  : "NO IMAGES AVAILABLE"
                                }
                                  
                                  </p> */}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <div className={`${styles.score_sec_box} ${styles.score_sec2}`}>
                        <div className={styles.score_head}>
                          <p>Teeboxes</p>
                          <button type="button" onClick={handleAddDraggableRow}>
                            <svg
                              id="Group_2002"
                              data-name="Group 2002"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                id="Ellipse_27"
                                data-name="Ellipse 27"
                                cx="10.4"
                                cy="10.4"
                                r="10.4"
                                transform="translate(1.6 1.6)"
                                fill="#fff"
                              ></circle>
                              <path
                                id="Vector"
                                d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5.25,13H13v4.25a1,1,0,0,1-2,0V13H6.75a1,1,0,0,1,0-2H11V6.75a1,1,0,0,1,2,0V11h4.25a1,1,0,0,1,0,2Z"
                                fill="#4cb0bd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        <div className={styles.formSec2}>
                          <DraggableList courseTeeDetails={courseScoreCardDetails?.teesList} 
                                        teeColorList={teeColorList} 
                                        teeTypeOptions={teeTypeList}
                                        onCreateTeeType={handleCreateTeeType}
                                        draggableTeeArray={handleNewTeeBoxArray}
                                        addedNewcourseTeeList={courseTeeList}
                                        //  onSelectColor={handleSelectTeeColor}  //  for pass color 
                                        />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className={styles.score_sec_box}>
                        <div className={styles.score_head}>
                          <p>Scorecard</p>
                        </div>
    
                        {/* {courseScoreCardDetails?.menScorecardList[0] ? */}
                          <div className={styles.formSec2}>
                              {/* {courseScoreCardDetails?.menScorecardList[0] && teeListArray?.length !== 0 ?  */}
                            {teeListArray?.length !== 0 && 
                              <div className={styles.table_sec}>
                              <table>
                        <thead>
                          <tr>
                            <th>TEE:</th>
                            <th>H1:</th>
                            <th>H2:</th>
                            <th>H3:</th>
                            <th>H4:</th>
                            <th>H5:</th>
                            <th>H6:</th>
                            <th>H7:</th>
                            <th>H8:</th>
                            <th>H9:</th>
                            <th>OUT:</th>
                            <th>H10:</th>
                            <th>H11:</th>
                            <th>H12:</th>
                            <th>H13:</th>
                            <th>H14:</th>
                            <th>H15:</th>
                            <th>H16:</th>
                            <th>H17:</th>
                            <th>H18:</th>
                            <th>IN:</th>
                          </tr>
                        </thead>
                            <tbody>
                            {/* {hole?.map((data,rowIndex) => ( */}
                            {scorecardTeeList?.map((data,rowIndex) => (
    
                              <tr>
                                <td>
                                  {/* <button
                                    className={`${styles.button}`}
                                    style={{
                                      backgroundColor: `${data[0]}`,
                                    }}
                                  ></button> */}
                                  <div className={`${styles.button}`}  style={{
                                      backgroundColor: `#${data[0]}`,
                                    }}></div>
                                </td>
                                {data
                                  ?.slice(1, data?.length)
                                  ?.map((item, index) =>
                                    index === 9 ? (
                                      <td>
                                        <p className={styles.total}>{data[10]}</p>
                                      </td>
                                    ) : index === 19 ? (
                                      <td>
                                        <p className={styles.total}>{data[20]}</p>
                                      </td>
                                    ) : (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField
                                            inputProps={{
                                              maxLength: 3,
                                              pattern: "[0-9]*",
                                            }}
                                            type="number"
                                            value={item} 
                                            onChange={(e) =>
                                              handleChangeTee(
                                                rowIndex,
                                                index,
                                                e.target.value
                                              )
                                            }
                                        
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0} 
                                            key={`textField-${rowIndex}-${index}`} 
                                          />
                                        </div>
                                      </td>
                                    )
                                  )}
                              </tr>
                            ))}
                        
                          </tbody>
                              </table>
                            </div>
                            }
                                  
                          <div className={styles.table_sec}>
                            <table>
                              <thead>
                                <tr>
                                  <th>PAR:</th>
                                  <th>H1:</th>
                                  <th>H2:</th>
                                  <th>H3:</th>
                                  <th>H4:</th>
                                  <th>H5:</th>
                                  <th>H6:</th>
                                  <th>H7:</th>
                                  <th>H8:</th>
                                  <th>H9:</th>
                                  <th>OUT:</th>
                                  <th>H10:</th>
                                  <th>H11:</th>
                                  <th>H12:</th>
                                  <th>H13:</th>
                                  <th>H14:</th>
                                  <th>H15:</th>
                                  <th>H16:</th>
                                  <th>H17:</th>
                                  <th>H18:</th>
                                  <th>IN:</th>
                                </tr>
                              </thead>
                              <tbody>
                            
                                  <tr>
                                  <td>
                                    <button
                                      className={`${styles.button} ${styles.default}`}
                                    >
                                      M
                                    </button>
                                  </td>
    
                                  {
                                  parForMnH9
                                    ?.slice(0, 9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField
                                            inputProps={{
                                              maxLength: 3,
                                              pattern: "[0-9]*",
                                            }}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setParForMnH9
                                              )
                                            }
                                            disabled={scorecardTeeList?.length === 0}
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(parForMnH9)}
                                    </p>
                                  </td>
                                  {
                                  parForMnH18?.slice(0,9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setParForMnH18
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            disabled={scorecardTeeList?.length === 0}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(parForMnH18)}
                                    </p>
                                  </td>
                                </tr> 
                              
    
                            
                                  <tr>
                                  <td>
                                    <button
                                      className={`${styles.button} ${styles.default}`}
                                    >
                                      W
                                    </button>
                                  </td>
    
                                  {
                                  parForWmnH9
                                    ?.slice(0, 9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField 
                                          disabled={scorecardTeeList?.length === 0}
                                            inputProps={{
                                              maxLength: 3,
                                              pattern: "[0-9]*",
                                            }}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setParForWmnH9
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(parForWmnH9)}
                                    </p>
                                  </td>
                                  {
                                  parForWmnH18?.slice(0,9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField  disabled={scorecardTeeList?.length === 0}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setParForWmnH18
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(parForWmnH18)}
                                    </p>
                                  </td>
                                </tr>
                                
                              </tbody>
                            </table>
                          </div>
      
                          <div className={styles.table_sec}>
                            <table>
                              <thead>
                                <tr>
                                  <th>HCP:</th>
                                  <th>H1:</th>
                                  <th>H2:</th>
                                  <th>H3:</th>
                                  <th>H4:</th>
                                  <th>H5:</th>
                                  <th>H6:</th>
                                  <th>H7:</th>
                                  <th>H8:</th>
                                  <th>H9:</th>
                                  <th>OUT:</th>
                                  <th>H10:</th>
                                  <th>H11:</th>
                                  <th>H12:</th>
                                  <th>H13:</th>
                                  <th>H14:</th>
                                  <th>H15:</th>
                                  <th>H16:</th>
                                  <th>H17:</th>
                                  <th>H18:</th>
                                  <th>IN:</th>
                                </tr>
                              </thead>
                              <tbody>
                                
                                  <tr>
                                  <td>
                                    <button
                                      className={`${styles.button} ${styles.default}`}
                                    >
                                      M
                                    </button>
                                  </td>
                                  
                          
                                    {
                                  HCPForMnH9?.slice(0, 9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField  disabled={scorecardTeeList?.length === 0}
                                            inputProps={{
                                              maxLength: 3,
                                              pattern: "[0-9]*",
                                            }}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setHCPForMnH9
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(HCPForMnH9)}
                                    </p>
                                  </td>
                                  {
                                  HCPForMnH18?.slice(0,9)?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField  disabled={scorecardTeeList?.length === 0}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setHCPForMnH18
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(HCPForMnH18)}
                                    </p>
                                  </td>
                                </tr>
                                  <tr>
                                  <td>
                                    <button
                                      className={`${styles.button} ${styles.default}`}
                                    >
                                      W
                                    </button>
                                  </td>
                                  {
                                  HCPForWmnH9?.slice(0, 9)
                                    ?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField  disabled={scorecardTeeList?.length === 0}
                                            inputProps={{
                                              maxLength: 3,
                                              pattern: "[0-9]*",
                                            }}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setHCPForWmnH9
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(HCPForWmnH9)}
                                    </p>
                                  </td>
                                  {
                                  //  courseScoreCardDetails?.wmnScorecardList[0]?.hcpHole?.slice(9, 18)
                                  HCPForWmnH18?.slice(0,9)?.map((item, index) => (
                                      <td>
                                        <div className={styles.form_grp}>
                                          <TextField  disabled={scorecardTeeList?.length === 0}
                                            type="number"
                                            defaultValue={item}
                                            onChange={(e) =>
                                              handleChange(
                                                index,
                                                e.target.value,
                                                setHCPForWmnH18
                                              )
                                            }
                                            onInput={(e) => {
                                              e.target.value = Math.max(
                                                0,
                                                parseInt(e.target.value)
                                              )
                                                .toString()
                                                .slice(0, 3);
                                            }}
                                            min={0}
                                          />
                                        </div>
                                      </td>
                                    ))}
                                  <td>
                                    <p className={styles.total}>
                                      {calculatedSum(HCPForWmnH18)}
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div> 
                      
                      </div>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </div>
          </div>
      </Wrapper>
      <ModalWrapper 
         noOnClose
         open={openNotesModal}
         onClose={() =>setOpenNotesModal(false)}
        //  handleClose= {() =>setOpenNotesModal(false)}
         className={`${stylesModal.cmn_modal2}  cmn_notes_modal`  }
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
         >
           <div className={stylesModal.modalMain} >
                    <div className={stylesModal.modalHeader_notes}>
                        <h4>Notes </h4>
                        <Button  onClick={() =>setOpenNotesModal(false)} className={stylesModal.btn_notes}>
                  <img src={asset.close} alt="" />
                </Button>
                    </div>

                    <Box className={`${_style.popover_ftr}`}>
                         <Box className={` ${_style.table_uppr}`}>
              <table 
                id={"list_table"}
                className={_style.score_table}
                style={{ userSelect: "none" }}
              >
                <thead>
                  {mappingNoteList?.length ? (
                    <>
                      {mappingNoteList?.map((note, index) => {
                        return (
                          <tr
                            key={index}
                            id={
                              index === mappingNoteList?.length - 1
                                ? "last_item"
                                : `item_${index}`
                            }
                          >
                            <td>
                              <Typography>
                                {note?.firstName}{" "}
                                {note?.firstName.charAt(0)?.toUpperCase()}.
                              </Typography>
                              <Typography>
                                {moment(note?.dateCreated).format("MM/DD/YYYY")}
                              </Typography>
                            </td>
                            <td>
                              <Typography>{note?.note}</Typography>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : null}
 
                </thead>
              </table>
                         </Box>

                         <form onSubmit={handleSubmitNotes(onSubmitNotes)}>
                          <Box className={` ${stylesModal.note_input}`}>
                <Controller
                  control={controlNotes}
                  name="notes"
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      placeholder="Add Note"
                      type="text"
                      value={value}
                      onChange={onChange}
                      disabled={false}
                      error={Boolean(errorsForNotes?.notes)}
                      helperText={errorsForNotes?.notes?.message}
                      // className="new_font_size"
                    />
                  )}
                />
                          </Box>
                          <Box className={` ${stylesModal.note_input}`}>
                            <Button type="submit" className={stylesModal.blue_btn}>Save</Button>
                          </Box>  
                         </form>
                    </Box>    
            </div>
          {/* </form> */}
         </ModalWrapper>

         
    </div>
  );
}